import { render, staticRenderFns } from "./expandAdviceList.vue?vue&type=template&id=12a7561c"
import script from "./expandAdviceList.vue?vue&type=script&lang=js"
export * from "./expandAdviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports